import ProducerCodeTitleHeader from "./ProducerCodeTitleHeader";
import ProducerCodeActionGroup from "./ProducerCodeActionGroup";
import { ProducerCodeForm } from "../forms/ProducerCodeForm";
import {
  isProducerCodeFilterOpen,
  prodCodeAddState,
  prodCodeEditState,
  prodCodeFilterOpen,
  prodCodeMassUpload,
  producerCodeShowState,
  producerCodeViewData,
  searchDataProducerCode,
  downloadLoading,
  prodCodeId,
  prodCodeCarrierName,
  officeShowStateModal,
  ofcToProducerCodeId,
  oncloseOfficeToProdCodeModal,
  isRefetchExpandedModal,
  fromViewModal,
  fromRecentActivity,
  fromRedirection,
  isShowFromEmployee,
} from "../atom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetProducerCodes from "../hooks/useGetProducerCodes";
import { toast } from "../../../../components/toastNotification";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ArrowRightIcon, FunnelIcon } from "@heroicons/react/24/solid";
import TableFilter from "../TableFilter";
import MassUpload from "../massupload/MassUpload";
import { useSearchProducerCode } from "../api/getProducerCodeSearch";
import { ProducerCodeFullGrpTbl } from "./ProducerCodeFullGrpPageTable";
import { prodCodeToOfficeId } from "../../OfficeSettings/atoms/atoms";
import Tooltip from "react-tooltip";
import useExportProducerCode from "../hooks/useExportProducerCode";

const ProducerCodeModule = () => {
  const [isAddState, setIsAddState] = useRecoilState(prodCodeAddState);
  const [isEditState, setIsEditState] = useRecoilState(prodCodeEditState);
  const [viewProdCodes, setViewProdCodes] = useRecoilState(
    producerCodeShowState
  );
  const [, setShowFromOfficeClose] = useRecoilState(
    oncloseOfficeToProdCodeModal
  );
  const [, setShowForModal] = useRecoilState(fromViewModal);
  const [rowViewData, setRowViewData] = useRecoilState(producerCodeViewData);
  const [filter, setFilter] = useRecoilState(prodCodeFilterOpen);
  const [massUpload, setMassUpload] = useRecoilState(prodCodeMassUpload);
  const searchInputsData = useRecoilValue(searchDataProducerCode);
  const [filteredProducerCodeData, setFilteredproducerCodeData] = useState<
    any[]
  >([]);
  const [isFilterMainTable, setIsFilterMainTable] = useState(false);
  const [, setFilterStatus] = useRecoilState(isProducerCodeFilterOpen);
  const [, setCarrierName] = useRecoilState(prodCodeCarrierName);
  const [, setIsDownloading] = useRecoilState(downloadLoading);
  const [, setFromRecentActivity] = useRecoilState(fromRecentActivity);

  const {
    data: groupedProducerCodes,
    isLoading: getGrpProdCodeLoading,
    refetch: refetchGetGrpProdCode,
    status: getGrpProdCodeStatus,
  } = useGetProducerCodes();

  const {
    isSuccess: searchProdCodeSuccess,
    data: filteredProdCodeData,
    isLoading: searchProdCodeLoading,
    refetch: searcProdCodeRefetch,
  } = useSearchProducerCode({ filterParams: searchInputsData });

  const [isSearchClick, setIsSearchClick] = useState(false);
  const [prodCodeData, setProdCodeData] = useState<any[]>([]);

  const tableRef = useRef<any>(0);
  const location = useLocation<any>();
  let recordIdFromRecent = { moduleName: "", state: null, action: "" } as any;
  const history = useHistory();

  // mounted guard to avoid setState on unmounted component
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Reset only when leaving the producer-code route.
  // If the pathname no longer includes this module base, we clear internal state.
  useEffect(() => {
    const pathname = location?.pathname ?? "";
    const base = "/carrieragreementmgmt/producercodeconfig";
    if (!String(pathname).toLowerCase().includes(base)) {
      if (!isMountedRef.current) return;
      setFilter(false);
      setIsAddState(false);
      setIsEditState(false);
      setIsDownloading(false);
      setFromRecentActivity(false);
      setIsSearchClick(false);
      setMassUpload(false);
      setFilteredproducerCodeData([]);
      setViewProdCodes(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (getGrpProdCodeStatus === "success" && groupedProducerCodes) {
      if (groupedProducerCodes.statusCode) {
        toast.fire("Server Error", "Cannot Get Producer Code Data", "error");
        if (isMountedRef.current) setProdCodeData([]);
      } else {
        if (isMountedRef.current)
          setProdCodeData(groupedProducerCodes?.map((data) => ({ ...data })));
      }
    }
  }, [getGrpProdCodeStatus, groupedProducerCodes]);

  useEffect(() => {
    if (searchProdCodeSuccess && filteredProdCodeData && isSearchClick) {
      if (filteredProdCodeData.statusCode) {
        toast.fire("Server Error", "Cannot Get Producer Code Data", "error");
        if (isMountedRef.current) setFilteredproducerCodeData([]);
      } else {
        if (isMountedRef.current) {
          setFilteredproducerCodeData(filteredProdCodeData);
          setIsFilterMainTable(true);
          setIsSearchClick(false);
        }
      }
    }
  }, [searchProdCodeSuccess, filteredProdCodeData]);

  const onClickCarrierName = (rowData) => {
    setRefetchCarrierProdCodeId(rowData.masterCarrierId);
    setViewProdCodes(true);
    setRowViewData({ ...rowData });
    setCarrierName(rowData.carrierName);
    localStorage.setItem("tablePage", tableRef.current.dataManager.currentPage);
  };

  const matColumns = [
    {
      field: "carrierName",
      render: (row) => (
        <div>
          <div
            className=" cursor-pointer w-full text-quinary font-bold font-sans text-base uppercase"
            onClick={() => {
              onClickCarrierName(row);
            }}
          >
            <span className="blueAndBold underline">{row.carrierName}</span>
          </div>
          <div className="w-full font-bold text-quinary uppercase"></div>
          <div className="text-xxs font-normal text-gray-600 uppercase">
            Carrier Name
          </div>{" "}
        </div>
      ),
    },
    {
      field: "producerCodes",
      render: (row) => {
        const producerCodes = row.producerCodes || "UNSPECIFIED";

        return (
          <div className="flex flex-col blueAndBold uppercase w-40">
            {producerCodes?.length > 20 ? (
              <span data-tip={producerCodes} data-for={"producerCode"}>
                <Tooltip
                  place="right"
                  className="w-[450px] whitespace-normal bg-white"
                  id="producerCode"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {producerCodes.substring(0, 20).trim() + "..."}
              </span>
            ) : (
              producerCodes
            )}

            <div className="mainLabeltextColor">
              {row?.masterCarrierId === 20 ? "Princeton Code" : "Producer Code"}
            </div>
          </div>
        );
      },
    },
    {
      hidden:
        (searchInputsData.MAProducerCode?.length === 0 && isFilterMainTable) ||
        !isFilterMainTable,
      field: "maProducerCode",
      render: (row) => {
        const maProducerCode = row.maProducerCode || "UNSPECIFIED";
        return (
          <div className="flex flex-col blueAndBold uppercase w-40">
            {maProducerCode?.length > 20 ? (
              <span data-tip={maProducerCode} data-for={"maProducerCode"}>
                <Tooltip
                  place="right"
                  className="w-[450px] whitespace-normal bg-white"
                  id="maProducerCode"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {maProducerCode.substring(0, 20).trim() + "..."}
              </span>
            ) : (
              maProducerCode
            )}
            <div className="mainLabeltextColor">M&A Producer Code</div>
          </div>
        );
      },
    },
    {
      hidden:
        (searchInputsData.selectedState?.length === 0 && isFilterMainTable) ||
        !isFilterMainTable,
      render: (row) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">{row.stateCode}</div>
            <div className={`mainLabeltextColor`}>State</div>
          </div>
        );
      },
    },
    {
      hidden:
        searchInputsData.selectedOffice?.length === 0 || !isFilterMainTable,
      render: (row) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">
              <div>
                {row.officeName} {" - "}
              </div>
              <div>
                {row.officeCode} {" - "} {row.storeNumber}
              </div>
            </div>
            <div className={`mainLabeltextColor`}>Office</div>
          </div>
        );
      },
    },
    {
      hidden:
        searchInputsData.selectedAcquisitionName?.length === 0 ||
        !isFilterMainTable,
      field: "acquisitionNames",
      render: (row) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">{row.acquisitionName}</div>
            <div className={`mainLabeltextColor`}>Acquisition Names</div>
          </div>
        );
      },
    },
    {
      field: "masterCarrierAddress",
      render: (row) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">
              {row.masterCarrierAddress
                ? row.masterCarrierAddress
                : "unspecified"}
            </div>

            <div className={`mainLabeltextColor`}>Carrier Address</div>
          </div>
        );
      },
    },
    {
      field: "isActive",
      customFilterAndSearch: (term, rowData) => {
        const statusText = rowData.isActive ? "Active" : "Inactive";
        return statusText.toLowerCase().includes(term.toLowerCase());
      },
      render: (rowData) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">
              {rowData.isActive === true ? "Active" : "Inactive"}
            </div>
            <div className="mainLabeltextColor">Carrier Status</div>
          </div>
        );
      },
    },
  ];
  const [, setShowFromOffice] = useRecoilState(officeShowStateModal);
  const setShowFromEmployee = useSetRecoilState(isShowFromEmployee);

  if (location.state !== "") {
    recordIdFromRecent = location.state;
  }

  const [, setCarrierProdCodeId] = useRecoilState(prodCodeId);
  const [, setproducerCodeId] = useRecoilState(ofcToProducerCodeId);
  const [, setProdCodeToOfficeId] = useRecoilState(prodCodeToOfficeId);
  const setShowModalFromRedi = useSetRecoilState(fromRedirection);
  const [RefetchCarrierProdCodeId, setRefetchCarrierProdCodeId] = useState("");
  const [isRefetchModal, setIsRefetchModal] = useRecoilState(
    isRefetchExpandedModal
  );

  // Filter for Carrier View Setting and from recent activity
  useEffect(() => {
    if (
      recordIdFromRecent?.action === "CarrierProducerCode" &&
      groupedProducerCodes?.length > 0
    ) {
      const filteredData = groupedProducerCodes?.filter(
        (x) => x.masterCarrierId === recordIdFromRecent?.masterCarrierId
      )[0];

      setCarrierProdCodeId(recordIdFromRecent?.carrierProducerCodeId);

      //Office
      if (recordIdFromRecent?.officeId) {
        setProdCodeToOfficeId(recordIdFromRecent.officeId);
        setShowFromOffice(true);
      }

      //Employee
      const empoyeeId = localStorage.getItem("employeeId");
      if (empoyeeId) {
        setShowFromEmployee(true);
      }

      setShowModalFromRedi(true);
      setRowViewData(filteredData);
      setViewProdCodes(true);
    }

    if (
      recordIdFromRecent?.action === "CloseOfficeToProd" &&
      groupedProducerCodes?.length > 0
    ) {
      var id: any = localStorage.getItem("ProducerCodeId");
      const filteredData = groupedProducerCodes?.filter(
        (x) => x.masterCarrierId === recordIdFromRecent?.masterCarrierId
      )[0];

      setProdCodeToOfficeId(recordIdFromRecent?.officeId);
      setRowViewData(filteredData);
      setShowFromOfficeClose(true);
      setproducerCodeId(id);
      setViewProdCodes(true);

      if (tableRef) {
        var pageNumber = localStorage.getItem("tablePage");
        tableRef.current.dataManager.currentPage = pageNumber;
      }
      if (recordIdFromRecent.fromRecent === true) {
        setIsFilterMainTable(true);
        const data = groupedProducerCodes?.filter(
          (x) => x.masterCarrierId === recordIdFromRecent?.masterCarrierId
        );
        setFilteredproducerCodeData(
          data?.map(({ tableData, ...data }) => {
            return data;
          })
        );
      }
      setFromRecentActivity(false);
    }
    if (
      recordIdFromRecent &&
      recordIdFromRecent?.moduleName === "Producer Code"
    ) {
      if (
        recordIdFromRecent?.action === "viewSettings" &&
        groupedProducerCodes
      ) {
        setFilterStatus(true);
        setIsFilterMainTable(true);
        setFilteredproducerCodeData(
          groupedProducerCodes?.filter(
            (x) => x.masterCarrierId === recordIdFromRecent?.recordId
          )
        );
      } else {
        setIsFilterMainTable(true);
        notificationFilterById(
          recordIdFromRecent.recordId?.toString(),
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName,
          recordIdFromRecent.action
        ).then((result) => {
          if (result) {
            if (result.exception) {
              setFilteredproducerCodeData([]);
              toast.fire(
                "Server Error",
                "Failed to retrieve Producer Code data",
                "error"
              );
            } else {
              setFilteredproducerCodeData(result);
              setFromRecentActivity(true);
            }
          }
        });
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
    if (
      recordIdFromRecent?.moduleName === "Employee" &&
      groupedProducerCodes?.length > 0
    ) {
      const filteredData = groupedProducerCodes?.filter(
        (x) => x.masterCarrierId === recordIdFromRecent?.masterCarrierId
      )[0];
      if (recordIdFromRecent?.producerCodeId !== "") {
        setproducerCodeId(recordIdFromRecent?.producerCodeId);
        setShowForModal(true);
      }
      setRowViewData(filteredData);
      setViewProdCodes(true);
    }
    if (
      recordIdFromRecent?.action === "CloseOfficeToProdModal" &&
      groupedProducerCodes?.length > 0
    ) {
      const filteredData = groupedProducerCodes?.filter(
        (x) => x.masterCarrierId === recordIdFromRecent?.masterCarrierId
      )[0];
      setproducerCodeId(recordIdFromRecent?.producerCodeId);
      setRowViewData(filteredData);
      setShowForModal(true);
      setViewProdCodes(true);
    }
    if (isRefetchModal && groupedProducerCodes?.length > 0) {
      const filteredData = groupedProducerCodes?.filter(
        (x) => x.masterCarrierId === RefetchCarrierProdCodeId
      )[0];
      setRowViewData(filteredData);
      setIsRefetchModal(false);
    }
  }, [groupedProducerCodes, recordIdFromRecent, isRefetchModal]);

  //#region Download
  const { mutateAsync: exportProdCode, isLoading: isLoadingExport } =
    useExportProducerCode();

  const downloadData = () => {
    const searchText = tableRef.current.dataManager.searchText;

    if (
      isFilterMainTable &&
      (filteredProducerCodeData?.length > 0 ||
        (searchText === "" && filteredProducerCodeData?.length === 0))
    ) {
      return filteredProducerCodeData;
    }
    if (searchText === "") {
      return prodCodeData;
    }
    return tableRef.current.dataManager.searchedData;
  };

  const downloadProducerCode = async () => {
    const data = downloadData();
    const converted = data.map((x) => ({
      ...x,
      isActive: x.isActive === "Active", // convert to boolean
    }));

    await exportProdCode(converted).catch((err) => {
      if (err?.message.toLowerCase() === "no data result") {
        toast.fire(
          "No Data to Export",
          "There are no records matching the selected filters",
          "warning"
        );
      }
    });
  };

  //#endregion

  return (
    <div className="px-8 py-4">
      {isAddState === true || isEditState === true ? (
        <div>
          <ProducerCodeForm
            setIsAddState={setIsAddState}
            setIsEditState={setIsEditState}
            isAddState={isAddState}
            isEditState={isEditState}
            refetchGetGrpProdCode={refetchGetGrpProdCode}
          />
        </div>
      ) : (
        <div>
          <div>
            {viewProdCodes && !isAddState && !isEditState && (
              <ProducerCodeFullGrpTbl rowData={rowViewData} />
            )}
          </div>
          <div>
            <div
              className={`${
                viewProdCodes || isAddState || isEditState || massUpload
                  ? "hidden"
                  : ""
              }`}
            >
              <div>
                <div className="flex items-center justify-between gap-4">
                  <ProducerCodeTitleHeader />
                  <button
                    type="button"
                    onClick={() =>
                      history.push("/carrieragreementmgmt/producercodeconfig")
                    }
                    className="inline-flex group hover:scale-90 transition duration-500 shadow-md px-3 py-1 h-7 text-xs font-semibold text-primary border hover:bg-primary hover:text-white border-primary rounded-md items-center"
                  >
                    <span>Back to Dashboard</span>
                    <span className="ml-2 inline-flex items-center justify-center rounded-full h-4 w-4 bg-primary  group-hover:bg-white transition">
                      <ArrowRightIcon
                        className="h-3 w-3 text-white group-hover:text-primary transform rotate-180"
                        aria-hidden="true"
                      />
                    </span>
                  </button>
                </div>
                <div className="pt-4 pb-2 flex justify-between ">
                  <button
                    className={`hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md ${
                      viewProdCodes && "opacity-50"
                    }`}
                    onClick={() => {
                      setFilter(!filter);
                    }}
                    disabled={viewProdCodes ? true : false}
                  >
                    <div>Filter By</div>
                    <FunnelIcon className="h-3 w-3" />
                  </button>
                  <ProducerCodeActionGroup
                    handleExportButton={downloadProducerCode}
                    isLoadingExport={isLoadingExport}
                  />
                </div>
              </div>
              <main className="flex justify-between ">
                {!viewProdCodes && !isEditState && !isAddState && filter && (
                  <div className="w-1/4 bg-white">
                    <div>
                      <TableFilter
                        searchProducerCode={searcProdCodeRefetch}
                        setFilteredproducerCodeData={
                          setFilteredproducerCodeData
                        }
                        setIsFilterMainTable={setIsFilterMainTable}
                        setIsSearchClick={setIsSearchClick}
                      />
                    </div>
                  </div>
                )}
                <div
                  className={
                    !filter
                      ? "mb-4 w-full bg-white overflow-x-auto box-shadow"
                      : "w-full h-5/6 bg-white px-2 overflow-x-auto mb-4"
                  }
                >
                  <MaterialTableTS
                    columns={matColumns}
                    data={
                      isFilterMainTable
                        ? filteredProducerCodeData
                        : prodCodeData?.map((data) => ({ ...data }))
                    }
                    isLoading={
                      getGrpProdCodeLoading
                        ? getGrpProdCodeLoading
                        : searchProdCodeLoading
                    }
                    headerStyle={{
                      display: "none",
                    }}
                    tableRef={tableRef}
                    toolbarSearch={true}
                    searchFieldAlignment="left"
                    showToolbar={true}
                  />
                </div>
              </main>
            </div>
          </div>
        </div>
      )}
      {massUpload && <MassUpload isOpen={massUpload} />}
    </div>
  );
};

export default ProducerCodeModule;
